import React, { useContext } from "react";
import classnames from "classnames";
import Styles from "./Achievements.module.scss";
import { AppContext } from "@vahak/core/dist/app-context";
import AppImg from "components/utils/AppImg";

interface DataProps {
    id: number;
    value: string;
    label: string;
    image: string;
    srcset?: string;
    altText?: string;
}

interface AchievemetsProps {
    achievementData: any;
    sectionTitle: string;
    sectionText?: string;
}

const Achievements = ({ achievementData, sectionTitle, sectionText }: AchievemetsProps) => {
    const { isMobile } = useContext(AppContext);
    return (
        <section className={Styles.main}>
            <div className={classnames(Styles.conainer, "container")}>
                <div className={Styles.heading}>
                    <h2>{sectionTitle}</h2>
                    <p>{sectionText}</p>
                </div>
                <div className={Styles.achieveRow}>
                    {achievementData.map((data: DataProps) => (
                        <div className={Styles.col} key={data.id}>
                            <div className={Styles.card}>
                                <div className={Styles.imgBox}>
                                    <AppImg
                                        src={data.image}
                                        layout="responsive"
                                        alt={data.altText}
                                        width={isMobile ? "92" : "130"}
                                        height={isMobile ? "48" : "71.75"}
                                    />
                                </div>
                                <div className={Styles.textBox}>
                                    <h4 className={Styles.value}>{data.value}</h4>
                                    <p className={Styles.label}>{data.label}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Achievements;
